import Http from '../http'

export default {
  generate(data){
    return Http.post(`/ai_flowise/generate_forms`,{
      ai_params: {
        ...data
      }
    })
  }
}